export default __webpack_public_path__ + "static/media/TTCommons-Medium.f6a38e81.woff2";